import styled from 'styled-components';
import {Link} from "gatsby";

const SecondaryButton = styled(Link)`
  border: 2px solid black;
  padding: 8px 16px;
  font-weight: bold;
  text-transform: lowercase;
  background: white;
  color: black;
  text-decoration: none;
  transition: 0.25s ease-in-out;
  cursor: pointer;

  :hover {
    background: #000;
    color: white;
  }
`;

const CloseButton = styled.a`
  border: 2px solid black;
  padding: 8px 16px;
  font-weight: bold;
  text-transform: lowercase;
  background: white;
  color: black;
  text-decoration: none;
  transition: 0.25s ease-in-out;
  cursor: pointer;

  :hover {
    background: #000;
    color: white;
  }
`;
export {SecondaryButton, CloseButton};
